<template>
  <v-container id="page-voucher-usage">
    <div class="page-title">{{ $route.name }}</div>
    <v-row>
      <v-col>
        <v-menu
          v-model="startMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <div style="width: 200px; display: inline-block;">
              <v-text-field
                v-model="startDate"
                label="시작일"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </div>
          </template>
          <c-date-picker
            v-model="startDate"
            @input="startMenu = false"
            firstDayOfWeek="1"
            :selectedDate="startDate"
            locale="ko-kr"
          ></c-date-picker>
        </v-menu>
        <v-menu
          v-model="endMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <div style="width: 200px; display: inline-block;">
              <v-text-field
                v-model="endDate"
                label="종료일"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </div>
          </template>
          <c-date-picker
            v-model="endDate"
            @input="endMenu = false"
            firstDayOfWeek="1"
            :selectedDate="endDate"
            locale="ko-kr"
          ></c-date-picker>
        </v-menu>
        <v-menu
          v-model="typeMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <div style="width: 200px; display: inline-block;">
              <v-select
                class="ml-1"
                v-model="searchType"
                :items="searchTypeList"
                label="검색타입"
                placeholder="바우처 명, 발급 대상"
                height="23"
                item-text="label"
                item-value="value"
              ></v-select>
            </div>
          </template>
        </v-menu>
        <v-menu
          v-model="keywordMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <div style="width: 200px; display: inline-block;">
              <v-text-field
                v-model="keyword"
                label="검색어"
                :placeholder="keywordPlaceholder"
                prepend-icon="search"
                v-on="on"
                maxlength="32"
                @keyup="onSearch"
              ></v-text-field>
            </div>
          </template>
        </v-menu>
      </v-col>
      <v-col class="d-flex justify-end">
        <c-btn
          color="blue"
          outlined
          iconName="assignment_return"
          @click="returnVoucherDialog = true"
          >바우처 반환</c-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <c-card outlined>
          <v-row cols="12" md="12" sm="12">
            <v-col cols="12" md="2" sm="6">
              <span class="title font-weight-bold mr-3">발급</span>
            </v-col>
            <v-col cols="12" md="1" sm="6">
              <span class="title font-weight-bold mr-5">{{
                this.counts.totalIssueCnt
              }}</span>
            </v-col>
            <v-col cols="12" md="2" sm="6">
              <span class="title font-weight-bold mr-3">사용</span>
            </v-col>
            <v-col cols="12" md="1" sm="6">
              <span class="title font-weight-bold mr-5">{{
                this.counts.totalUseCnt
              }}</span>
            </v-col>
            <v-col cols="12" md="2" sm="6">
              <span class="title font-weight-bold mr-3">미사용</span>
            </v-col>
            <v-col cols="12" md="1" sm="6">
              <span class="title font-weight-bold mr-5">{{
                this.counts.totalremainCnt
              }}</span>
            </v-col>
            <v-col cols="12" md="2" sm="6">
              <span class="title font-weight-bold mr-3">반환</span>
            </v-col>
            <v-col cols="12" md="1" sm="6">
              <span class="title font-weight-bold mr-5 red--text">{{
                this.counts.totalBackCnt
              }}</span>
            </v-col>
          </v-row>
        </c-card>
      </v-col>
    </v-row>
    <c-table
      :headers="tableHeader"
      :items="voucherList"
      itemKey="id"
      multi-sort
      show-select
      :selected.sync="selected"
      :page="pagination.page"
      :itemsPerPage="pagination.size"
      :totalElements="totalElements"
      @update:tableOptions="updateOption"
    >
      <template #issueDate="{item}">
        {{ item.issueDate ? $func.dateToString(item.issueDate) : "" }}
      </template>
      <template #expirationDate="{item}">
        {{ item.expirationDate ? $func.dateToString(item.expirationDate) : "" }}
      </template>
      <template #issueCnt="{item}">
        {{ item.issueCnt }}
      </template>
      <template #remainCnt="{item}">
        {{ item.remainCnt }}
      </template>
      <template #detail="{item}">
        <c-btn icon iconName="search" @click="onMoveDetail(item)" />
      </template>
    </c-table>

    <voucher-back-dialog
      :open.sync="returnVoucherDialog"
      :selected="selected"
      @reqBackVoucher="reqBackVoucher"
    />
  </v-container>
</template>

<script>
import VoucherBackDialog from "./VoucherBackDialog";

export default {
  components: {
    VoucherBackDialog,
  },
  data() {
    return {
      startDate: this.$func.curDateStringAddDays(-7),
      endDate: this.$func.curDateString(),
      counts: {
        totalIssueCnt: 0,
        totalUseCnt: 0,
        totalremainCnt: 0,
        totalBackCnt: 0,
      },
      keyword: "",
      startMenu: false,
      endMenu: false,
      keywordMenu: false,
      typeMenu: false,
      returnVoucherDialog: false,
      tableHeader: [
        {
          text: "바우처 명",
          value: "name",
          align: "center",
          sortable: true,
        },
        {
          text: "발급 대상",
          value: "customerName",
          align: "center",
          sortable: true,
        },
        {
          text: "지급일",
          value: "issueDate",
          align: "center",
          sortable: true,
        },
        {
          text: "만료일",
          value: "expirationDate",
          align: "center",
          sortable: true,
        },
        {
          text: "발급 개수",
          value: "issueCnt",
          align: "center",
          sortable: true,
        },
        {
          text: "남은 개수",
          value: "remainCnt",
          align: "center",
          sortable: true,
        },
        {
          text: "상세보기",
          value: "detail",
          align: "center",
          sortable: false,
        },
      ],
      voucherList: [],
      tableData: [],
      selected: [],
      searchType: "VOUCHER_NAME",
      searchTypeList: [
        {
          label: "바우처 명",
          value: "VOUCHER_NAME",
        },
        {
          label: "발급 대상",
          value: "CUSTOMER_NAME",
        },
      ],
      pagination: {
        page: 1,
        size: 10,
        sort: "",
      },
      totalElements: 0,
    };
  },
  watch: {
    startDate: function() {
      this.reqVoucherStateList();
    },
    endDate: function() {
      this.reqVoucherStateList();
    },
  },
  activated() {
    this.reqVoucherStateList();
  },
  computed: {
    keywordPlaceholder() {
      return this.searchType === "VOUCHER_NAME" ? "바우처 명" : "발급 대상";
    },
  },
  methods: {
    async reqVoucherStateList() {
      try {
        const res = await this.$api.getVoucherStateListBetween(
          this.startDate,
          this.endDate,
          {
            ...this.pagination,
            searchType: this.searchType,
            searchKeyword: this.keyword,
          }
        );

        this.voucherList = res.data.list.content;
        this.totalElements = res.data.list.totalElements;
        this.counts = {
          totalIssueCnt: res.data.stat.issueCnt,
          totalUseCnt: res.data.stat.useCnt,
          totalremainCnt: res.data.stat.unusedCnt,
          totalBackCnt: res.data.stat.returnCnt,
        };
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqVoucherStateList" });
      }
    },
    async reqBackVoucher(data) {
      try {
        for (const idx in data) {
          let reqData = {
            id: data[idx].id,
            remainCnt: data[idx].remainCnt,
            backCnt: data[idx].backCnt,
          };
          const res = await this.$api.BackVoucherState(reqData);
        }

        this.returnVoucherDialog = false;
        this.selected = [];
        this.reqVoucherStateList();
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqBackVoucher" });
      }
    },
    onMoveDetail(item) {
      this.$router.push(`/voucherUsage/${item.id}`);
    },
    updateOption(option) {
      this.pagination.page = option.page;
      this.pagination.size = option.itemsPerPage;
      if (option.sortBy.length > 0 && option.sortDesc.length > 0) {
        this.pagination.sort = `${option.sortBy[0]},${
          option.sortDesc[0] ? "asc" : "desc"
        }`;
      }
      this.reqVoucherStateList();
    },
    onSearch(event) {
      if (event.key === "Enter") {
        this.pagination.page = 1;
        this.reqVoucherStateList();
      } else {
        return;
      }
    },
  },
};
</script>

<style scoped></style>
